export default __webpack_public_path__ + "static/media/delete.92723330.svg";